import { BatchesService } from '@festina/unitlink-general-types/unitlink/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteUnitLinkBatch = () =>
  useFestinaMutation({
    component: 'unitLink',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: async (arg: MethodParam) => await method(arg),
  })
